import React from "react";
import AppRoutes from "./Routes";

const App: React.FC = () => {
  return (
    <>
      <div className="main-container h-100">
        <AppRoutes />
      </div>
    </>
  );
};

export default App;
